export var vocabularyFormConfig = {
    tabs: [
        {
            id: 'basic',
            labelKey: 'ui-czna-authorities.vocabularies.advancedEdit.tab.basic',
            fields: [
                {
                    tag: '901',
                    labelKey: 'ui-czna-authorities.vocabularies.advancedEdit.field.901',
                    subfields: [
                        {
                            code: 'a',
                            labelKey: 'ui-czna-authorities.marc.901.subfield.a',
                            required: true,
                            defaultVisible: true,
                            colSpan: 8,
                        },
                        {
                            code: 'c',
                            labelKey: 'ui-czna-authorities.marc.901.subfield.c',
                            defaultVisible: true,
                            colSpan: 4,
                        },
                    ],
                },
            ],
        },
    ],
};
